// extracted by mini-css-extract-plugin
module.exports = {"followers":"follows_followers__2sqqM"};